const countdown = [
  {
    date: "January 1, ",
    holiday: "Eclipse Elegance"
  },
  {
    date: "February 14, ",
    holiday: "Valloween"
  },
  {
    date: "March 8, ",
    holiday: "Mystic Femininity"
  },
  {
    date: "March 17, ",
    holiday: "Shamrock Shadows"
  },
  {
    date: "April 20, ",
    holiday: "420"
  },
  {
    date: "May 12, ",
    holiday: "Maternal Majesty"
  },
  {
    date: "May 22, ",
    holiday: "World Goth Day"
  },
  {
    date: "June 16, ",
    holiday: "Paternal Essence"
  },
  {
    date: "June 20, ",
    holiday: "Midsummer Night's Dream"
  },
  {
    date: "July 4, ",
    holiday: "Nocturnal Independence"
  },
  {
    date: "July 5, ",
    holiday: "Siren's Song"
  },
  {
    date: "August 10, ",
    holiday: "Enchanted Education"
  },
  {
    date: "October 31, ",
    holiday: "Hallowed Harvest"
  },
  {
    date: "November 29, ",
    holiday: "Obsidian Friday"
  },
  {
    date: "December 25, ",
    holiday: "Yuletide Shadows"
  },
  {
    date: "December 31, ",
    holiday: "Eternal Euphoria"
  }
];
const today = new Date();
let year = today.getFullYear();
const slideshow = document.getElementsByTagName("slideshow-component")[0].getElementsByClassName("slideshow")[0].getElementsByClassName("slideshow__slide");
for (let i=0; i < slideshow.length; i++) {
  const heading = slideshow[i].getElementsByClassName("banner__heading")[0];
  const text = heading.innerText;
  const holiday = countdown.find(day => day.holiday === text);
  if (holiday) {
    const upcoming = new Date(`${holiday.date} ${year} 00:00:00`);
    const timeUntil = upcoming.getTime() - today.getTime();
    const daysUntil = Math.ceil(timeUntil / (1000 * 60 * 60 * 24));
    let textReplacement;
    if (daysUntil === 0) {
      textReplacement = `It's ${holiday.holiday}!`;  
    } else if (daysUntil < 0) {
      textReplacement = `Sorry we missed you for ${holiday.holiday}. See you next time.`;
    } else if (daysUntil === 1) {
      textReplacement = `${daysUntil} day until ${holiday.holiday}!`;
    } else {
      textReplacement = `${daysUntil} days until ${holiday.holiday}!`;
    }
    heading.innerHTML = heading.innerHTML.replace(text, textReplacement);
  } 
}
